import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getUserAddresses = async (userId, token) => {
  const res = await axios.get(`${BASE_URL}/delivery-address?userId=${userId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data.addresses;
};

export const createAddress = async (data, token) => {
  const res = await axios.post(`${BASE_URL}/delivery-address`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const updateAddress = async (id, data, token) => {
  const res = await axios.put(`${BASE_URL}/delivery-address/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const deleteAddress = async (id, userId, token) => {
  const res = await axios.delete(`${BASE_URL}/delivery-address/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
    data: { userId },  
  });
  return res.data;
};

export const setDefaultAddress = async (id, userId, token) => {
  const res = await axios.patch(`${BASE_URL}/delivery-address/${id}/set-default`, { userId }, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};